import { entries } from "../data/entries"
import { Box, Container, Grid } from "@mui/material"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell, { tableCellClasses } from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"
import React, { useEffect, useState } from "react"
import { SEO } from "../components/SEO"
import { PATHS } from "../constants/paths"
import { ReferralProgram } from "../components/ReferralProgram"
import { RarityItem } from "../components/boxes/RarityItem"
import { NftCard } from "../components/boxes/NftCard"
import { useAppSelector } from "../store"
import { getCommanderBoxes } from "../api/boxes"
import { BoxList } from "../components/boxes/BoxList"

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 18,
    "@media (max-width: 600px)": {
      fontSize: 16,
    },
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 20,
    "@media (max-width: 600px)": {
      fontSize: 16,
    },
  },
}))

export const NftBoxesCommanders2 = () => {
  const { user } = useAppSelector((state) => state.user)

  const [boxes, setBoxes] = useState([])

  const loadBoxes = async () => {
    const data = (await getCommanderBoxes()) || []
    setBoxes(data)
  }

  useEffect(() => {
    let mounted = true

    ;(async () => {
      if (!mounted) return
      await loadBoxes()
    })()

    const intervalId = setInterval(() => {
      if (mounted) {
        loadBoxes()
      }
    }, 2000)

    return () => {
      mounted = false
      clearInterval(intervalId)
    }
  }, [])

  return (
    <Box>
      <SEO
        title="Zombie TD | Buy NFT Commander Boxes - Lead Your Army"
        description="Get NFT Commander Boxes to unlock special commanders with unique skills and bonuses."
        ogTitle="Zombie TD | NFT Commander Boxes"
        ogDescription="Purchase NFT Commander Boxes and lead your army to victory with powerful abilities."
        ogUrl={PATHS.NFT_BOXES.NFT_BOXES_WITH_COMMANDERS.PATH}
      />
      <Box className="content content-nft-boxes content-nft-boxes-commanders">
        <Box className="content-head" mb={5} textAlign="center">
          <Container fixed>
            <Typography variant="h1">NFT Boxes with Commanders 2</Typography>
            <Typography
              variant="subtitle1"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Sales Starts In: TBA
            </Typography>
            {/*<Box sx={{display: 'flex', justifyContent: 'center', mt: 2}}>*/}
            {/*  <TimeLeft y={2022} m={10} d={10}/>*/}
            {/*</Box>*/}
          </Container>
        </Box>
        <Box className="content-body">
          <Container fixed>
            <Box>
              <BoxList boxes={boxes} user={user} />
            </Box>

            <Box sx={{ mt: { xs: 4, sm: 6, md: 8 } }}>
              <Typography variant="h2" textAlign={"center"} gutterBottom>
                NFT Commanders Overview
              </Typography>

              <Typography variant="subtitle1" mb={2}>
                NFT Commanders actively participate in battles and gain
                <span className={"primary"}>
                  experience, gold, and rating points
                </span>
                , regardless of the outcome.With each new level, a Commander
                grants <span className={"primary"}>3 upgrade points</span> that
                can be allocated to improve:{" "}
                <span className={"primary"}>
                  gold gain, Commander experience gain, Turret attack power, and
                  token staking rewards
                </span>
                .
              </Typography>

              <Typography variant="subtitle1" mb={2}>
                In addition,{" "}
                <span className={"primary"}>
                  NFT Commanders accelerate the leveling and effectiveness
                  growth of Turrets within their specialization
                </span>
                , allowing you to upgrade key weapons faster and reach higher
                power thresholds sooner.
              </Typography>

              <Typography variant="subtitle1" mb={2}>
                There are{" "}
                <span className={"primary"}>5 types of NFT Commanders</span>,
                each specialized in enhancing a specific Turret type. Each
                Commander boosts{" "}
                <span className={"primary"}>
                  damage, radius, and unique effects
                </span>{" "}
                of their assigned Turret class:
              </Typography>

              <Grid container spacing={2} sx={{ mb: 4 }}>
                {entries.commanders.map((commander) => {
                  return (
                    <>
                      {commander.id > 1 && (
                        <Grid item xs={6} sm={6} md={3} lg>
                          <Typography
                            variant="h4"
                            textAlign={"center"}
                            sx={{
                              my: 2,
                              fontSize: {
                                xs: 12,
                                md: 14,
                              },
                            }}
                          >
                            {commander.title}
                          </Typography>
                          <NftCard
                            image={commander.image}
                            video={commander.video}
                          />
                          <Box textAlign="center">
                            <Typography
                              variant="body1"
                              sx={{ color: "#EEE" }}
                              mt={1}
                            >
                              {commander.brief}
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                    </>
                  )
                })}
              </Grid>
            </Box>

            <Box
              textAlign="center"
              sx={{
                mt: { xss: 2, xs: 5, sm: 6, md: 8, lg: 10 },
                mb: { lg: 5 },
              }}
            >
              <Typography variant="h2" mb={2}>
                NFT Commander Boxes & Rarity
              </Typography>

              <Typography variant="subtitle1" mb={2} textAlign="left">
                Each Commander Box contains{" "}
                <span className={"primary"}>one random NFT Commander</span> of a
                specific type, with varying{" "}
                <span className={"primary"}>stats and rarity</span>. NFT
                Commanders can be:{" "}
                <span className={"primary"}>
                  Used in gameplay to strengthen Turrets, Staked within the
                  ecosystem, Traded on the marketplace…
                </span>
              </Typography>

              <Typography variant="subtitle1" mb={2} textAlign="left">
                Higher-rarity Commanders have{" "}
                <span className={"primary"}>a lower drop chance</span>, but
                provide{" "}
                <span className={"primary"}>
                  stronger bonuses, higher efficiency boosts, increased staking
                  potential, and greater marketplace value
                </span>
                .
              </Typography>

              <Typography variant="subtitle1" mb={2} textAlign="left">
                Rare Commanders are powerful strategic assets for rankings,
                events, PvP, and long-term progression.
              </Typography>
            </Box>

            <Box maxWidth={820} sx={{ margin: "auto" }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Rarity</StyledTableCell>
                      <StyledTableCell>Distribution (%)</StyledTableCell>
                      <StyledTableCell>Pieces per 200</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <RarityItem
                      level={"Common"}
                      probability={"60%"}
                      amount={"120"}
                    />
                    <RarityItem
                      level={"Uncommon"}
                      probability={"30%"}
                      amount={"60"}
                    />
                    <RarityItem
                      level={"Rare"}
                      probability={"7%"}
                      amount={"14"}
                    />
                    <RarityItem
                      level={"Epic"}
                      probability={"2.5%"}
                      amount={"5"}
                    />
                    <RarityItem
                      level={"Legendary"}
                      probability={"0.5%"}
                      amount={"1"}
                    />
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <ReferralProgram view="commanders" />
          </Container>
        </Box>
      </Box>
    </Box>
  )
}
